// extracted by css-extract-rspack-plugin
export default {"cardEmail":"cardEmail-t1XU_u","contactIcon":"contactIcon-wuWqJx","contactList":"contactList-vOltwB","personalEmail":"personalEmail-K07VyN","linkedinIcon":"linkedinIcon-Umtwkn"};